/* ============
 * Supplier Module State
 * ============
 */

export default {
  all: [],
  items: [],
  pagination: {
    currentPage: 1,
    lastPage: 0,
    limit: 5,
    totalCount: 0,
  },
  currentStock: [],
  stockProducts: [],
  stockProductsCustom: [],
  warehouseId: 0,
};



// WEBPACK FOOTER //
// ./src/app/store/modules/stock/state.js